import Swal from 'sweetalert2';
import i18next from '../i18n';

const NOTIFICATION_TIME = 5000;
const modals = {
  UploadConnectionError: {
    iconName: 'cancel',
    message: {
      en: 'Oops, looks like there was a problem with your internet',
      ar: 'عفوًا ، حدثت مشكلة في الاتصال بالشبكة. الرجاء المحاولة مرة اخرى.',
    },
  },
  FileSizeError: {
    iconName: 'cancel',
    message: {
      en: 'The file size cannot exceed 5 MB',
      ar: 'لا يمكن تحميل ملف أكبر من 5 ميجابايت',
    },
  },
  FileFormatError: {
    iconName: 'cancel',
    message: {
      en: 'The file format is not supported',
      ar: 'نوع الملف غير مدعوم',
    },
  },
  ConversionError: {
    iconName: 'cancel',
    message: {
      en: 'Failed to process the file',
      ar: 'لم يتم معالجة الملف',
    },
  },
  NetworkError: {
    iconName: 'cancel',
    message: {
      en: 'A network interruption occurred. Please try again',
      ar: 'حدث انقطاع في الشبكة. الرجاء إعادة المحاول مرة اخرى',
    },
  },
  TeacherSubmissionSaveSuccess: {
    iconName: 'cancel',
    message: {
      en: 'Submission has been saved!',
      ar: 'تم حفظ التغييرات',
    },
    type: 'success',
  },
  TeacherSubmissionReturnSuccess: {
    iconName: 'cancel',
    message: {
      en: 'Student assignment evaluation(s) have been returned.',
      ar: 'تم إرجاع تقييم المهمة للطلبة',
    },
    type: 'success',
  },
  TeacherSubmissionReturnSingleSuccess: {
    iconName: 'cancel',
    message: {
      en: "Student's assignment evaluation has been returned.",
      ar: 'تم إرجاع تقييم المهمة للطلبة',
    },
    type: 'success',
  },
  TeacherResubmissionSuccess: {
    iconName: 'cancel',
    message: {
      en: 'Resubmission Requested',
      ar: 'تم طلب إعادة إرسال الواجب',
    },
    type: 'success',
  },
  VideoFileDurationLimit: {
    iconName: 'cancel',
    message: {
      en:
        'The file cannot be uploaded because it is more than 5 mins in duration/length',
      ar: 'لا يمكن تحميل الملف لأن مدته الزمنيه أكثر من 5 دقائق',
    },
  },
  TeacherResponseAttachmentError: {
    iconName: 'cancel',
    message: {
      en:
        'Please select a document to upload.  Images, audio and video file formats are not permitted.',
      ar:
        'الرجاء اختيار الملف المراد تحميله. غير مسموح بالصور ، ملفات الصوت والفيديو',
    },
  },
  lockedStudentByCount: {
    iconName: 'cancel',
    type: 'success',
  },
  lockedStudentByName: {
    iconName: 'cancel',
    type: 'success',
  },
  evaluatedStudentByName: {
    iconName: 'cancel',
    type: 'success',
  },
  unEvaluatedStudentByName: {
    iconName: 'cancel',
    type: 'success',
  },
  returnedStudentsByCount: {
    iconName: 'cancel',
    type: 'success',
  },
  returnedStudentsByName: {
    iconName: 'cancel',
    type: 'success',
  },
  unlockedStudentByCount: {
    iconName: 'cancel',
    type: 'success',
  },
  unlockedStudentByName: {
    iconName: 'cancel',
    type: 'success',
  },
  evaluatedExceedTheMaxScoreError: {
    iconName: 'cancel',
  },
};

function getNotificationData(modalName) {
  return modals[modalName] || { iconName: '', message: '' };
}

export default function fireNotification(
  modalName,
  lang = 'en',
  customMessage = '',
) {
  const { message, type } = getNotificationData(modalName);
  const i18nTranslation = i18next.t(message && message.en);
  document.documentElement.style.setProperty(
    '--popupBgColor',
    type === 'success' ? '#03a86b' : '#b90330',
  );
  Swal.fire({
    position: 'bottom',
    title: `<span class='usprivacy' style='${
      i18next.dir() === 'rtl' ? 'text-align: right;' : ''
    }' data-testid='swal-notification' data-recording-sensitive>${customMessage ||
      i18nTranslation ||
      message[lang]}</span>`,
    showConfirmButton: false,
    timer: NOTIFICATION_TIME,
    showCloseButton: true,
    backdrop: false,
    toast: true,
    background: 'transparent',
    customClass: {
      container: 'alef-assignment-swal2',
    },
  });
}

export { modals };
